<template>
  <billing-report-panel
    report-key="transfer-insurance"
    route="/reports/billing-transfer-insurance"
    file-name="repasse-por-convenio.xlsx"
    period-label="Período do faturamento"
    :columns="columns"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Convênio e plano',
        'Itens',
        'Faturado e recebido no período',
        'Repasse sobre o faturado',
        'Repasse sem faturamento próprio (laudos e retornos)',
        'Retido pela clínica',
        'Percentual médio de repasse',
        'Subtotal por convênio',
      ],
    };
  },
};
</script>
